document.addEventListener("DOMContentLoaded", function () {
  var scrollToTopBtn = document.getElementById("scrollToTop");
  // Sektionen kan vaere slaaet fra i editoren; saa skal intet binde eller fejle
  if (!scrollToTopBtn) return;

  var stickyBarVisible = !!document.querySelector(".sticky-atc.is-visible");

  function update() {
    // Skjules mens produktsidens sticky koebsbar er synlig, saa knappen ikke ligger oven paa "Laeg i kurv"
    var show = window.scrollY > 300 && !stickyBarVisible;
    scrollToTopBtn.style.display = show ? "flex" : "none";
  }

  // Vis/skjul knappen afhaengigt af scroll-position
  window.addEventListener("scroll", update, { passive: true });

  // Sticky koebsbar (snippets/sticky-add-to-cart.liquid) melder naar den vises/skjules
  document.addEventListener("wl:sticky-atc", function (event) {
    stickyBarVisible = !!(event.detail && event.detail.visible);
    update();
  });

  // Scroll til toppen naar knappen klikkes
  scrollToTopBtn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});
